import * as actionTypes from '../actions/actionTypes';
import moment from "moment";
import { updateObject } from '../utility'

const initialState = {
    counter: 0,
    barLoading: false,
    flightsNotFound: false,
	  serviceData: null,
    requestParams: null,
    airportName: null,
    cityName: null,
    airlineNames: null,
    airportNames: null,
    cityNames: null,
    departDate: null,
    arrivalDate: null,
    searchId: null,
    flightType: null,
    flightCode: null,
    flightCodeRound: null,
    destination: '',
    taxLabel: null,
    flightMessage: null,
    isPriceClicked: false,
    isDurationClicked: false,
    disablePrice: false,
    isPriceActive: true,
    isDurationActive: false,
    priceSortedBy: true,
    searchUsed: false,
    totalTravellers: 0,
    pollingIds: [],
    pollingCount: 0,
    loading: true,
    error: false,
    dom: {
        oneWayFlightsSingle: [],
        oneWayFlightsCombined: [],
        roundTripFlights: {
            roundTripOnward: [],
            roundTripReturn: []
        },
        roundTripOnward: null,
        roundTripReturn: null,
    },
    int: {
      oneWayFlightsSingle: [],
      oneWayFlightsCombined: [],
      roundTripFlights: null,
      intRoundTripDepart: [],
      intRoundTripReturn: []
    },
    flightsFound: 0,
    filters: {
        ts: [],
        tlot: [],
        tf: [],
        ac: [],
        ft: [],
        dd: [],
        ddR: []
    },
    selectedStops: [],
    selectedLayovers: [],
    selectedDepartures: [],
    selectedReturns: [],
    selectedFlights: [],
    refundableArray: [],
    priceFilterSelected: false,
    durationFilterSelected: false,
    departureFlightFiltersSelected: false,
    arrivalFlightFiltersSelected: false,
    returnPriceFilterSelected: false,
    returnDurationFilterSelected: false,
    returnDepartureFlightFiltersSelected: false,
    returnArrivalFlightFiltersSelected: false,
    isNonStopChecked: false
}

let pollingIds = [];
let pollingCount = 0;

let Filters = {
  ts: [],
  tlot: [],
  tf: [],
  ac: [],
  ft: [],
  dd: [],
  ddR: []
};

let filters = {
  ts: [],
  tlot: [],
  tf: [],
  ac: [],
  ft: [],
  dd: [],
  ddR: []
};

let isRefundableFilterSelected = false;

let isStopOver0Selected = false;
let isStopOver1Selected = false;
let isStopOver2Selected = false;

let isLayoverTime0Selected = false;
let isLayoverTime1Selected = false;
let isLayoverTime2Selected = false;
let isLayoverTime3Selected = false;

let isDepartureTiming0Selected = false;
let isDepartureTiming1Selected = false;
let isDepartureTiming2Selected = false;
let isDepartureTiming3Selected = false;

let isReturnTiming0Selected = false;
let isReturnTiming1Selected = false;
let isReturnTiming2Selected = false;
let isReturnTiming3Selected = false;

let airlineNames = {};
let cityNames = {};
let airportNames = {};
let taxLabel = {};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_BAR_LOADING:
          return updateObject(state, { barLoading: true })
        case actionTypes.SET_FLIGHTS:
            let loading = true;
            let barLoading = true;
            let serviceData = null;
            const requestParams = action.flights.requestParams ? action.flights.requestParams : state.requestParams;
            const cityName = action.flights.cityName ? action.flights.cityName : state.cityName;
            const airportName = action.flights.airportName ? action.flights.airportName : state.airportName;
            if(action.isPolling === false) {
              if(JSON.parse(action.flights.eagerFetch) === false) {
                pollingIds = action.flights.pollingIds;
              } else if(JSON.parse(action.flights.eagerFetch) === true) {
                if(action.flights.pollingIds) {
                  if(action.flights.pollingIds.length === 0) {
                    barLoading = false;
                  } else {
                    barLoading = true;
                  }
                }
              }
            } else {
              pollingCount += 1;
            }
						if(state.serviceData !== null) {
              action.flights.resultData = action.flights.resultData.concat(state.serviceData);
						}
						if(JSON.parse(action.flights.eagerFetch) === true) {
                serviceData = action.flights.resultData;
            }
            if (action.flights.resultData.length >= 0 && JSON.parse(action.flights.eagerFetch) === true) {
                loading = false;
            }
            if(pollingCount === pollingIds.length) {
              barLoading = false;
            }            
            for (let i = 0; i < action.flights.resultData.length; i++) {
              const flightSchedule = action.flights.resultData[i].fltSchedule;
              Object.assign(airlineNames, flightSchedule.airlineNames);
              Object.assign(airportNames, flightSchedule.airportNames);
              Object.assign(cityNames, flightSchedule.cityNames);
              Object.assign(taxLabel, flightSchedule.taxLabel);
            }
            const searchId = requestParams.searchId;
            const totalTravellers = parseInt(requestParams.ADT, 10) + parseInt(requestParams.CHD, 10) + parseInt(requestParams.INF, 10);
            const departDate = requestParams.flight_depart_date || '';
            const arrivalDate = requestParams.arrivalDate || '';
            const flightType = requestParams.type;
            let flightCode = '';
            let flightCodeRound = '';
            let oneWayFlightsSingle = [];
            let oneWayFlightsCombined = [];
            let roundTripFlights = {
              roundTripOnward: [],
              roundTripReturn: []
            };
            let dom = {};
            let int = {};
            let flightsFound = 0;
            let tempRoundTripFlights = null;
            let tempDepartArray = [];
            let tempReturnArray = [];
        
            if(requestParams.originCountry !== "IN" || requestParams.destinationCountry !== "IN") {
              if (flightType === 'O') {
                flightCode = requestParams.origin + requestParams.destination + moment(requestParams.flight_depart_date, "DD/MM/YYYY").format("YYYYMMDD");
                oneWayFlightsSingle = sortFlights(action.flights, flightCode);
                oneWayFlightsCombined = getOneWayFlights([...oneWayFlightsSingle]);
                flightsFound = oneWayFlightsSingle.length;

                int = {
                  oneWayFlightsSingle: oneWayFlightsSingle,
                  oneWayFlightsCombined: oneWayFlightsCombined,
                  roundTripFlights: null,
                }

                dom = {
                  oneWayFlightsSingle: [],
                  oneWayFlightsCombined: [],
                  roundTripFlights: {
                      roundTripOnward: [],
                      roundTripReturn: []
                  },
                  roundTripOnward: null,
                  roundTripReturn: null,
                }
              } else if (flightType === 'R') {
                flightCode = requestParams.origin + requestParams.destination + moment(requestParams.flight_depart_date, "DD/MM/YYYY").format("YYYYMMDD");
                flightCodeRound = requestParams.destination + requestParams.origin + moment(requestParams.arrivalDate, "DD/MM/YYYY").format("YYYYMMDD");
                if (!action.flights.resultData[0].fareDetails) {
                  action.flights.resultData[0].fltSchedule[flightCode] = null;
                }
                roundTripFlights = airlineCombine(sortFlights(action.flights, flightCode));
                const mergedArrays = [].concat.apply([], roundTripFlights);
                flightsFound = mergedArrays.length;
                tempRoundTripFlights = airlineCombine(sortFlights(action.flights, flightCode));
                let tempDepart = [];
                let tempReturn = [];
                for (let i = 0; i < tempRoundTripFlights.length; i++) {
                  for (let j = 0; j < tempRoundTripFlights[i].length; j++) {

                    tempRoundTripFlights[i][j].OD[0].ID = tempRoundTripFlights[i][j].ID;
                    tempRoundTripFlights[i][j].OD[1].ID = tempRoundTripFlights[i][j].ID;
                    tempRoundTripFlights[i][j].OD[0].xmlKey = tempRoundTripFlights[i][j].xmlKey;
                    tempRoundTripFlights[i][j].OD[1].xmlKey = tempRoundTripFlights[i][j].xmlKey;
                    tempRoundTripFlights[i][j].OD[0].FD = tempRoundTripFlights[i][j].FD;
                    tempRoundTripFlights[i][j].OD[1].FD = tempRoundTripFlights[i][j].FD;
                    
                    tempDepart.push(tempRoundTripFlights[i][j].OD[0]);
                    tempReturn.push(tempRoundTripFlights[i][j].OD[1]);
                  }
                    const uniqueDepart = removeDuplicatesHandler(tempDepart, "fid");
                    const uniqueReturn = removeDuplicatesHandler(tempReturn, "fid");
                    tempDepartArray.push(uniqueDepart);
                    tempReturnArray.push(uniqueReturn);
                    tempDepart = [];
                    tempReturn = [];
                }

                int = {
                  oneWayFlightsSingle: [],
                  oneWayFlightsCombined: [],
                  intRoundTripDepart: tempDepartArray,
                  intRoundTripReturn: tempReturnArray,
                  intRoundTripDepartOriginal: tempDepartArray,
                  intRoundTripReturnOriginal: tempReturnArray
                }


                dom = {
                  oneWayFlightsSingle: [],
                  oneWayFlightsCombined: [],
                  roundTripFlights: {
                      roundTripOnward: [],
                      roundTripReturn: []
                  },
                  roundTripOnward: null,
                  roundTripReturn: null,
                }
              }
            } else {
              if (flightType === 'O') {
              	flightCode = requestParams.origin + requestParams.destination + moment(requestParams.flight_depart_date, "DD/MM/YYYY").format("YYYYMMDD");
                oneWayFlightsSingle = sortFlights(action.flights, flightCode);
                oneWayFlightsCombined = getOneWayFlights([...oneWayFlightsSingle]);
                flightsFound = oneWayFlightsSingle.length;
                
                dom = {
                    oneWayFlightsSingle: oneWayFlightsSingle,
                    oneWayFlightsCombined: oneWayFlightsCombined,
                    roundTripFlights: {
                        roundTripOnward: [],
                        roundTripReturn: []
                    },
                    roundTripOnward: null,
                    roundTripReturn: null,
                }
            } else if (flightType === 'R') {
              flightCode = requestParams.origin + requestParams.destination + moment(requestParams.flight_depart_date, "DD/MM/YYYY").format("YYYYMMDD");
              flightCodeRound = requestParams.destination + requestParams.origin + moment(requestParams.arrivalDate, "DD/MM/YYYY").format("YYYYMMDD");
              roundTripFlights = getRoundTripFlights(action.flights, flightCode, flightCodeRound);
              dom = {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: roundTripFlights,
                roundTripOnward: roundTripFlights.roundTripOnward,
                roundTripReturn: roundTripFlights.roundTripReturn
              }
              flightsFound = roundTripFlights.roundTripOnward.length + roundTripFlights.roundTripReturn.length;
              }
            }
            return updateObject(state, {
				serviceData: serviceData,
              	requestParams: requestParams,
                cityName: cityName,
                airportName: airportName,
                airlineNames: airlineNames,
                airportNames: airportNames,
                cityNames: cityNames,
                taxLabel: taxLabel,
                flightCode: flightCode,
                flightCodeRound: flightCodeRound,
                searchId: searchId,
                dom: dom,
                int: int,
                flightsFound: flightsFound,
                totalTravellers: totalTravellers,
                flightType: flightType,
                departDate: departDate,
                arrivalDate: arrivalDate,
                filters: filters,
                pollingIds: pollingIds,
                pollingCount: pollingCount,
                loading: loading,
                barLoading: barLoading
            })
        case actionTypes.UPDATE_INT_ROUND_TRIP_TUPLE:
            let intTemp = {
              oneWayFlightsSingle: [],
              oneWayFlightsCombined: [],
              roundTripFlights: null,
              intRoundTripDepart: [],
              intRoundTripReturn: []
            }
            if (action.intRoundTripType === 'depart') {
              const intDepart = [...state.int.intRoundTripDepart];
              const temp = intDepart[action.tupleIndex][0];
              intDepart[action.tupleIndex][0] = intDepart[action.tupleIndex][action.itemIndex];
              intDepart[action.tupleIndex][action.itemIndex] = temp;
              intTemp = {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: state.int.roundTripFlights,
                intRoundTripDepart: intDepart,
                intRoundTripReturn: state.int.intRoundTripReturn
              }
            } else {
              const intReturn = [...state.int.intRoundTripReturn];
              const temp = intReturn[action.tupleIndex][0];
              intReturn[action.tupleIndex][0] = intReturn[action.tupleIndex][action.itemIndex];
              intReturn[action.tupleIndex][action.itemIndex] = temp;
              intTemp = {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: state.int.roundTripFlights,
                intRoundTripDepart: state.int.intRoundTripDepart,
                intRoundTripReturn: intReturn
              }
            }
            return updateObject(state, { int: intTemp, counter: state.counter + 1 })
        case actionTypes.INCREASE_POLLING_COUNTER:
            pollingCount += 1;
            if(pollingCount === pollingIds.length) {
              barLoading = false;
            }
            return updateObject(state, {barLoading: barLoading})
        case actionTypes.SHOW_FLIGHTS_NOT_FOUND:
            return updateObject(state, {
              barLoading: false,
              loading: false,
              flightsNotFound: true
            })
        case actionTypes.RESET_POLLING_COUTNER:
            pollingCount = 0;
            return {...state};
        case actionTypes.GET_FLIGHTS_FAILED:
            return updateObject(state, {error: true, loading: false})
        case actionTypes.SET_LOADING:
            return updateObject(state, {loading: true})
        case actionTypes.HIDE_LOADING:
            return updateObject(state, {loading: false})
        case actionTypes.HIDE_RETURN_FLIGHTS:
            return updateObject(state, {returnFlights: false});
        case actionTypes.FILTER_BY_PRICE:
            const temp2 = [];
            let oneWayFlightsCombinedUpdated = null;
            let returnFlightsCombinedUpdated = null;
            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'R') {
                oneWayFlightsCombinedUpdated = state.dom.roundTripFlights.roundTripOnward;
                returnFlightsCombinedUpdated = state.dom.roundTripFlights.roundTripReturn;
              } else {
                oneWayFlightsCombinedUpdated = state.dom.oneWayFlightsSingle;
              }
            } else {
              oneWayFlightsCombinedUpdated = state.int.oneWayFlightsCombined;
            }
              if(state.flightType === 'O') {
                oneWayFlightsCombinedUpdated = priceClickedHandler(oneWayFlightsCombinedUpdated, state.isPriceClicked);
                [...oneWayFlightsCombinedUpdated].forEach(flight => {
                  temp2.push([flight]);
                })
              } else {
                if(action.tripType === "onward") {
                  oneWayFlightsCombinedUpdated = priceClickedHandler(oneWayFlightsCombinedUpdated, state.isPriceClicked);
                } else {
                  returnFlightsCombinedUpdated = priceClickedHandler(returnFlightsCombinedUpdated, state.isPriceClicked);
                }
              }
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                if(state.flightType === 'O') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp2,
                    },
                    priceFilterSelected: true,
                    durationFilterSelected: false,
                    departureFlightFiltersSelected: false,
                    arrivalFlightFiltersSelected: false,
                    returnPriceFilterSelected: false,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: false,
                    returnArrivalFlightFiltersSelected: false
                  }
                } else {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      roundTripFlights: {
                        roundTripOnward: oneWayFlightsCombinedUpdated,
                        roundTripReturn: returnFlightsCombinedUpdated
                      },
                    },
                    priceFilterSelected: action.tripType === "onward" ? true : false,
                    durationFilterSelected: false,
                    departureFlightFiltersSelected: false,
                    arrivalFlightFiltersSelected: false,
                    returnPriceFilterSelected: action.tripType === "onward" ? false : true,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: false,
                    returnArrivalFlightFiltersSelected: false,
                  }
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    oneWayFlightsCombined: temp2,
                  },
                  priceFilterSelected: true,
                  durationFilterSelected: false,
                  departureFlightFiltersSelected: false,
                  arrivalFlightFiltersSelected: false
                }
            }
        case actionTypes.FILTER_BY_DURATION:
            const temp = [];
            let oneWayFlightsSingleUpdated = null;
            let returnFlightsSingleUpdated = null;
            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'R') {
                oneWayFlightsSingleUpdated = state.dom.roundTripFlights.roundTripOnward;
                returnFlightsSingleUpdated = state.dom.roundTripFlights.roundTripReturn;
              } else {
                oneWayFlightsSingleUpdated = state.dom.oneWayFlightsCombined;
              }
            } else {
              oneWayFlightsSingleUpdated = state.int.oneWayFlightsCombined;
            }
            if(state.flightType === 'O') {
              oneWayFlightsSingleUpdated = durationClickedHandler(oneWayFlightsSingleUpdated, state.isDurationClicked);
              [...oneWayFlightsSingleUpdated].forEach(flight => {
                temp.push([flight]);
              })
            } else {
              if(action.tripType === "onward") {
                oneWayFlightsSingleUpdated = durationClickedHandler(oneWayFlightsSingleUpdated, state.isDurationClicked);
              } else {
                returnFlightsSingleUpdated = durationClickedHandler(returnFlightsSingleUpdated, state.isDurationClicked);
              }
            }
            const sortedFilteredResults = {
              roundTripOnward: oneWayFlightsSingleUpdated,
              roundTripReturn: returnFlightsSingleUpdated
            }
            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'O') {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    oneWayFlightsCombined: temp,
                  },
                  durationFilterSelected: true,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false,
                  arrivalFlightFiltersSelected: false,
                  returnPriceFilterSelected: false,
                  returnDurationFilterSelected: false,
                  returnDepartureFlightFiltersSelected: false,
                  returnArrivalFlightFiltersSelected: false
                }
              } else {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    roundTripFlights: sortedFilteredResults,
                  },
                  durationFilterSelected: action.tripType === "onward" ? true : false,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false,
                  arrivalFlightFiltersSelected: false,
                  returnPriceFilterSelected: false,
                  returnDurationFilterSelected: action.tripType === "onward" ? false : true,
                  returnDepartureFlightFiltersSelected: false,
                  returnArrivalFlightFiltersSelected: false,
                }
              }
            } else {
              return {
                ...state,
                int: {
                  ...state.int,
                  oneWayFlightsCombined: temp,
                },
                durationFilterSelected: true,
                priceFilterSelected: false,
                departureFlightFiltersSelected: false,
                arrivalFlightFiltersSelected: false
              }
          }
          case actionTypes.FILTER_BY_FLIGHT_DEPARTURE:
              const temp3 = [];
              let oneWayFlightsSingleUpdated2 = null;
              let returnFlightsSingleUpdated2 = null;
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                if(state.flightType === 'R') {
                  oneWayFlightsSingleUpdated2 = state.dom.roundTripFlights.roundTripOnward;
                  returnFlightsSingleUpdated2 = state.dom.roundTripFlights.roundTripReturn;
                } else {
                  oneWayFlightsSingleUpdated2 = state.dom.oneWayFlightsCombined;
                }
              } else {
                oneWayFlightsSingleUpdated2 = state.int.oneWayFlightsCombined;
              }
              if(state.flightType === 'O') {
                oneWayFlightsSingleUpdated2 = departureClickedHandler(oneWayFlightsSingleUpdated2);
                [...oneWayFlightsSingleUpdated2].forEach(flight => {
                  temp3.push([flight]);
                })
              } else {
                if(action.tripType === "onward") {
                  oneWayFlightsSingleUpdated2 = departureClickedHandler(oneWayFlightsSingleUpdated2);
                } else {
                  returnFlightsSingleUpdated2 = departureClickedHandler(returnFlightsSingleUpdated2);
                }
              }
              const newResults = {
                roundTripOnward: oneWayFlightsSingleUpdated2,
                roundTripReturn: returnFlightsSingleUpdated2
              }
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                if(state.flightType === 'O') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp3,
                    },
                    departureFlightFiltersSelected: true,
                    durationFilterSelected: false,
                    priceFilterSelected: false,
                    arrivalFlightFiltersSelected: false,
                    returnPriceFilterSelected: false,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: false,
                    returnArrivalFlightFiltersSelected: false
                  }
                } else {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      roundTripFlights: newResults,
                    },
                    departureFlightFiltersSelected: action.tripType === "onward" ? true : false,
                    durationFilterSelected: false,
                    priceFilterSelected: false,
                    arrivalFlightFiltersSelected: false,
                    returnPriceFilterSelected: false,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: action.tripType === "onward" ? false : true,
                    returnArrivalFlightFiltersSelected: false
                  }
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    oneWayFlightsCombined: temp3,
                  },
                  departureFlightFiltersSelected: true,
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  arrivalFlightFiltersSelected: false
                }
            }
          case actionTypes.FILTER_BY_FLIGHT_ARRIVAL:
              const temp4 = [];
              let oneWayFlightsSingleUpdated3 = null;
              let returnFlightsSingleUpdated3 = null;
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                if(state.flightType === 'R') {
                  oneWayFlightsSingleUpdated3 = state.dom.roundTripFlights.roundTripOnward;
                  returnFlightsSingleUpdated3 = state.dom.roundTripFlights.roundTripReturn;
                } else {
                  oneWayFlightsSingleUpdated3 = state.dom.oneWayFlightsCombined;
                }
              } else {
                oneWayFlightsSingleUpdated3 = state.int.oneWayFlightsCombined;
              }
              if(state.flightType === 'O') {
                oneWayFlightsSingleUpdated3 = arrivalClickedHandler(oneWayFlightsSingleUpdated3);
                [...oneWayFlightsSingleUpdated3].forEach(flight => {
                  temp4.push([flight]);
                })
              } else {
                if(action.tripType === "onward") {
                  oneWayFlightsSingleUpdated3 = arrivalClickedHandler(oneWayFlightsSingleUpdated3);
                } else {
                  returnFlightsSingleUpdated3 = arrivalClickedHandler(returnFlightsSingleUpdated3);
                }
              }
              const newResults2 = {
                roundTripOnward: oneWayFlightsSingleUpdated3,
                roundTripReturn: returnFlightsSingleUpdated3
              }
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                if(state.flightType === 'O') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp4,
                    },
                    departureFlightFiltersSelected: false,
                    durationFilterSelected: false,
                    priceFilterSelected: false,
                    arrivalFlightFiltersSelected: true,
                    returnPriceFilterSelected: false,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: false,
                    returnArrivalFlightFiltersSelected: false,
                  }
                } else {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      roundTripFlights: newResults2,
                    },
                    departureFlightFiltersSelected: false,
                    durationFilterSelected: false,
                    priceFilterSelected: false,
                    arrivalFlightFiltersSelected: action.tripType === "onward" ? true : false,
                    returnPriceFilterSelected: false,
                    returnDurationFilterSelected: false,
                    returnDepartureFlightFiltersSelected: false,
                    returnArrivalFlightFiltersSelected: action.tripType === "onward" ? false : true,
                  }
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    oneWayFlightsCombined: temp4,
                  },
                  departureFlightFiltersSelected: false,
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  arrivalFlightFiltersSelected: true
                }
            } 
        case actionTypes.TOGGLE_NON_STOP_FLIGHTS:
            const temp11 = [];
            let filteredResults = null;
            let oneWayFlightsCombinedUpdatedCopy = null;
            let returnFlightsCombinedUpdatedCopy = null;
            let internationalFilterResults1 = null;

            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'R') {
                oneWayFlightsCombinedUpdatedCopy = state.dom.roundTripOnward;
                returnFlightsCombinedUpdatedCopy = state.dom.roundTripReturn;
              } else {
                oneWayFlightsCombinedUpdatedCopy = state.dom.oneWayFlightsSingle;
              }
            } else {
              if(state.flightType === 'R') {
                oneWayFlightsCombinedUpdatedCopy = state.int.intRoundTripDepartOriginal;
                returnFlightsCombinedUpdatedCopy = state.int.intRoundTripReturnOriginal;
              } else {
                oneWayFlightsCombinedUpdatedCopy = state.int.oneWayFlightsSingle;
              }
            }
            if(!isStopOver0Selected) {
              Filters.ts.push(0);
              isStopOver0Selected = !isStopOver0Selected;
            } else {
              const index = Filters.ts.indexOf(0);
              if(index > -1) {
                Filters.ts.splice(index, 1);
              }
              isStopOver0Selected = !isStopOver0Selected;
            }
            let selectedStopsCopy = [...state.selectedStops];
            if(selectedStopsCopy.includes(0)) {
              const selectedStopIndex = selectedStopsCopy.indexOf(0);
              if(selectedStopIndex > -1) {
                selectedStopsCopy.splice(selectedStopIndex, 1);
              } 
            } else {
              selectedStopsCopy.push(0);  
            }
            if(returnFlightsCombinedUpdatedCopy != null) {
              if(state.flightType === 'R' && (state.requestParams.destinationCountry !== 'IN' || state.requestParams.originCountry !== 'IN')) {
                internationalFilterResults1 = multiFilterInt(oneWayFlightsCombinedUpdatedCopy, returnFlightsCombinedUpdatedCopy);
              } else {
                const onwardResult = multiFilter(oneWayFlightsCombinedUpdatedCopy, Filters);
                const returnResult = multiFilter(returnFlightsCombinedUpdatedCopy, Filters, "return");
                filteredResults = {
                  roundTripOnward: onwardResult,
                  roundTripReturn: returnResult
                };
              }
            } else {
              filteredResults = multiFilter(oneWayFlightsCombinedUpdatedCopy, Filters);
            }
            if(state.flightType === 'O') {
              [...filteredResults].forEach(flight => {
                temp11.push([flight]);
              })
            }
            if(state.flightType === 'R') {
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    roundTripFlights: filteredResults
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: selectedStopsCopy
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    intRoundTripDepart: internationalFilterResults1.intRoundTripDepart,
                    intRoundTripReturn: internationalFilterResults1.intRoundTripReturn
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: selectedStopsCopy
                }
            }
            } else {
                if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp11
                    },
                    filters: JSON.parse(JSON.stringify(Filters)),
                    selectedStops: selectedStopsCopy
                  }
                } else {
                  return {
                    ...state,
                    int: {
                      ...state.int,
                      oneWayFlightsCombined: temp11
                    },
                    filters: JSON.parse(JSON.stringify(Filters)),
                    selectedStops: selectedStopsCopy
                  }
              }
            }
        case actionTypes.TOGGLE_REFUNDABLE_FLIGHTS:
            const temp12 = [];
            let filteredResults12 = null;
            let oneWayFlightsCombinedUpdatedCopy12 = null;
            let returnFlightsCombinedUpdatedCopy12 = null;
            let internationalFilterResults2 = null;
            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'R') {
                oneWayFlightsCombinedUpdatedCopy12 = state.dom.roundTripOnward;
                returnFlightsCombinedUpdatedCopy12 = state.dom.roundTripReturn;
              } else {
                oneWayFlightsCombinedUpdatedCopy12 = state.dom.oneWayFlightsSingle;
              }
            } else {
              if(state.flightType === 'R') {
                oneWayFlightsCombinedUpdatedCopy12 = state.int.intRoundTripDepartOriginal;
                returnFlightsCombinedUpdatedCopy12 = state.int.intRoundTripReturnOriginal;
              } else {
                oneWayFlightsCombinedUpdatedCopy12 = state.int.oneWayFlightsSingle;
              }
            }
            if(!isRefundableFilterSelected) {
              Filters.ft.push(1);
              isRefundableFilterSelected = !isRefundableFilterSelected;
            } else {
              const index = Filters.ft.indexOf(1);
              if(index > -1) {
                Filters.ft.splice(index, 1);
              }
              isRefundableFilterSelected = !isRefundableFilterSelected;
            }
            let refundableCopy = [...state.refundableArray];
            if(refundableCopy.includes(1)) {
              const refundableIndex = refundableCopy.indexOf(1);
              if(refundableIndex > -1) {
                refundableCopy.splice(refundableIndex, 1);
              } 
            } else {
              refundableCopy.push(1);  
            }
            if(returnFlightsCombinedUpdatedCopy12 != null) {
              if(state.flightType === 'R' && (state.requestParams.destinationCountry !== 'IN' || state.requestParams.originCountry !== 'IN')) {
                internationalFilterResults2 = multiFilterInt(oneWayFlightsCombinedUpdatedCopy12, returnFlightsCombinedUpdatedCopy12);
              } else {
                const onwardResult = multiFilter(oneWayFlightsCombinedUpdatedCopy12, Filters);
                const returnResult = multiFilter(returnFlightsCombinedUpdatedCopy12, Filters, "return");
                filteredResults12 = {
                  roundTripOnward: onwardResult,
                  roundTripReturn: returnResult
                };
              }
            } else {
              filteredResults12 = multiFilter(oneWayFlightsCombinedUpdatedCopy12, Filters);
            }
            if(state.flightType === 'O') {
              [...filteredResults12].forEach(flight => {
                temp12.push([flight]);
              })
            }
            if(state.flightType === 'R') {
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    roundTripFlights: filteredResults12
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  refundableArray: refundableCopy
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    intRoundTripDepart: internationalFilterResults2.intRoundTripDepart,
                    intRoundTripReturn: internationalFilterResults2.intRoundTripReturn
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  refundableArray: refundableCopy
                }
            }
            } else {
                if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp12
                    },
                    filters: JSON.parse(JSON.stringify(Filters)),
                    refundableArray: refundableCopy
                  }
                } else {
                  return {
                    ...state,
                    int: {
                      ...state.int,
                      oneWayFlightsCombined: temp12
                    },
                    filters: JSON.parse(JSON.stringify(Filters)),
                    refundableArray: refundableCopy
                  }
              }
            }
        case actionTypes.FILTER_BY_LAYOVER_TIME:
            if(action.timeIndex === 0) {
              if(!isLayoverTime0Selected) {
                Filters.tlot.push(action.timeIndex);
                isLayoverTime0Selected = !isLayoverTime0Selected;
              } else {
                const index = Filters.tlot.indexOf(action.timeIndex);
                if(index > -1) {
                  Filters.tlot.splice(index, 1);
                }
                isLayoverTime0Selected = !isLayoverTime0Selected;
              }
            }
            if(action.timeIndex === 1) {
              if(!isLayoverTime1Selected) {
                Filters.tlot.push(action.timeIndex);
                isLayoverTime1Selected = !isLayoverTime1Selected;
              } else {
                const index = Filters.tlot.indexOf(action.timeIndex);
                if(index > -1) {
                  Filters.tlot.splice(index, 1);
                }
                isLayoverTime1Selected = !isLayoverTime1Selected;
              }
            }
            if(action.timeIndex === 2) {
              if(!isLayoverTime2Selected) {
                Filters.tlot.push(action.timeIndex);
                isLayoverTime2Selected = !isLayoverTime2Selected;
              } else {
                const index = Filters.tlot.indexOf(action.timeIndex);
                if(index > -1) {
                  Filters.tlot.splice(index, 1);
                }
                isLayoverTime2Selected = !isLayoverTime2Selected;
              }
            }
            if(action.timeIndex === 3) {
              if(!isLayoverTime3Selected) {
                Filters.tlot.push(action.timeIndex);
                isLayoverTime3Selected = !isLayoverTime3Selected;
              } else {
                const index = Filters.tlot.indexOf(action.timeIndex);
                if(index > -1) {
                  Filters.tlot.splice(index, 1);
                }
                isLayoverTime3Selected = !isLayoverTime3Selected;
              }
            }
            let selectedLayovers = [...state.selectedLayovers];
            if(selectedLayovers.includes(action.timeIndex)) {
              const selectedLayoverIndex = selectedLayovers.indexOf(action.timeIndex);
              if(selectedLayoverIndex > -1) {
                selectedLayovers.splice(selectedLayoverIndex, 1);
              } 
            } else {
              selectedLayovers.push(action.timeIndex);  
            }
            return {
              ...state,
              selectedLayovers: selectedLayovers
            }
        case actionTypes.FILTER_BY_AIRLINES:
            if(Filters.ac.includes(action.airlineCode)) {
              const index = Filters.ac.indexOf(action.airlineCode);
              if(index > -1) {
                Filters.ac.splice(index, 1);
              }
            } else {
              Filters.ac.push(action.airlineCode);
            }
            let selectedFlights = [...state.selectedFlights];
            if(selectedFlights.includes(action.airlineCode)) {
              const selectedFlightIndex = selectedFlights.indexOf(action.airlineCode);
              if(selectedFlightIndex > -1) {
                selectedFlights.splice(selectedFlightIndex, 1);
              }
            } else {
              selectedFlights.push(action.airlineCode);
            }
            return {
              ...state,
              selectedFlights: selectedFlights
            }
        case actionTypes.FILTER_BY_DEPARTURE_TIMING:
          if(action.timeIndex === 0) {
            if(!isDepartureTiming0Selected) {
              Filters.dd.push(action.timeIndex);
              isDepartureTiming0Selected = !isDepartureTiming0Selected; 
            } else {
              const index = Filters.dd.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.dd.splice(index, 1);
              }
              isDepartureTiming0Selected = !isDepartureTiming0Selected;
            }
          }
          if(action.timeIndex === 1) {
            if(!isDepartureTiming1Selected) {
              Filters.dd.push(action.timeIndex);
              isDepartureTiming1Selected = !isDepartureTiming1Selected; 
            } else {
              const index = Filters.dd.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.dd.splice(index, 1);
              }
              isDepartureTiming1Selected = !isDepartureTiming1Selected;
            }
          }
          if(action.timeIndex === 2) {
            if(!isDepartureTiming2Selected) {
              Filters.dd.push(action.timeIndex);
              isDepartureTiming2Selected = !isDepartureTiming2Selected; 
            } else {
              const index = Filters.dd.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.dd.splice(index, 1);
              }
              isDepartureTiming2Selected = !isDepartureTiming2Selected;
            }
          }
          if(action.timeIndex === 3) {
            if(!isDepartureTiming3Selected) {
              Filters.dd.push(action.timeIndex);
              isDepartureTiming3Selected = !isDepartureTiming3Selected; 
            } else {
              const index = Filters.dd.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.dd.splice(index, 1);
              }
              isDepartureTiming3Selected = !isDepartureTiming3Selected;
            }
          }
            let selectedDepartures = [...state.selectedDepartures];
            if(selectedDepartures.includes(action.timeIndex)) {
              const selectedDeparturesIndex = selectedDepartures.indexOf(action.timeIndex);
              if(selectedDeparturesIndex > -1) {
                selectedDepartures.splice(selectedDeparturesIndex, 1);
              } 
            } else {
              selectedDepartures.push(action.timeIndex);  
            }
            return {
              ...state,
              selectedDepartures: selectedDepartures
            }
        case actionTypes.FILTER_BY_RETURN_TIMING:
          if(action.timeIndex === 0) {
            if(!isReturnTiming0Selected) {
              Filters.ddR.push(action.timeIndex);
              isReturnTiming0Selected = !isReturnTiming0Selected; 
            } else {
              const index = Filters.ddR.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.ddR.splice(index, 1);
              }
              isReturnTiming0Selected = !isReturnTiming0Selected;
            }
          }
          if(action.timeIndex === 1) {
            if(!isReturnTiming1Selected) {
              Filters.ddR.push(action.timeIndex);
              isReturnTiming1Selected = !isReturnTiming1Selected; 
            } else {
              const index = Filters.ddR.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.ddR.splice(index, 1);
              }
              isReturnTiming1Selected = !isReturnTiming1Selected;
            }
          }
          if(action.timeIndex === 2) {
            if(!isReturnTiming2Selected) {
              Filters.ddR.push(action.timeIndex);
              isReturnTiming2Selected = !isReturnTiming2Selected; 
            } else {
              const index = Filters.ddR.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.ddR.splice(index, 1);
              }
              isReturnTiming2Selected = !isReturnTiming2Selected;
            }
          }
          if(action.timeIndex === 3) {
            if(!isReturnTiming3Selected) {
              Filters.ddR.push(action.timeIndex);
              isReturnTiming2Selected = !isReturnTiming2Selected; 
            } else {
              const index = Filters.ddR.indexOf(action.timeIndex);
              if(index > -1) {
                Filters.ddR.splice(index, 1);
              }
              isReturnTiming3Selected = !isReturnTiming3Selected;
            }
          }
          let selectedReturns = [...state.selectedReturns];
          if(selectedReturns.includes(action.timeIndex)) {
            const selectedReturnsIndex = selectedReturns.indexOf(action.timeIndex);
            if(selectedReturnsIndex > -1) {
              selectedReturns.splice(selectedReturnsIndex, 1);
            } 
          } else {
            selectedReturns.push(action.timeIndex);  
          }
          return {
            ...state,
            selectedReturns: selectedReturns
          }
        case actionTypes.RESET_FILTERS:
            Filters = {
              ts: [],
              tlot: [],
              tf: [],
              ac: [],
              ft: [],
              dd: [],
              ddR: []
            }
            isStopOver0Selected = false;
            isStopOver1Selected = false;
            isStopOver2Selected = false;
            isLayoverTime0Selected = false;
            isLayoverTime1Selected = false;
            isLayoverTime2Selected = false;
            isLayoverTime3Selected = false;
            isDepartureTiming0Selected = false;
            isDepartureTiming1Selected = false;
            isDepartureTiming2Selected = false;
            isDepartureTiming3Selected = false;
            isReturnTiming0Selected = false; 
            isReturnTiming1Selected = false;
            isReturnTiming2Selected = false;
            isReturnTiming3Selected = false;

            if(state.flightType === "R") {
              if(state.requestParams.originCountry === "IN" && state.requestParams.destinationCountry === "IN") {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    roundTripFlights: {roundTripOnward: state.dom.roundTripOnward, roundTripReturn: state.dom.roundTripReturn}
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: [],
                  selectedLayovers: [],
                  selectedDepartures: [],
                  selectedFlights: [],
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    roundTripFlights: {roundTripOnward: state.roundTripOnward, roundTripReturn: state.roundTripReturn}
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: [],
                  selectedLayovers: [],
                  selectedDepartures: [],
                  selectedFlights: [],
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false
                }
              }
            } else {
              if(state.requestParams.originCountry === "IN" && state.requestParams.destinationCountry === "IN") {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    oneWayFlightsCombined: airlineCombine([...state.dom.oneWayFlightsSingle])
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: [],
                  selectedLayovers: [],
                  selectedDepartures: [],
                  selectedFlights: [],
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    oneWayFlightsCombined: airlineCombine([...state.int.oneWayFlightsSingle])
                  },
                  filters: JSON.parse(JSON.stringify(Filters)),
                  selectedStops: [],
                  selectedLayovers: [],
                  selectedDepartures: [],
                  selectedFlights: [],
                  durationFilterSelected: false,
                  priceFilterSelected: false,
                  departureFlightFiltersSelected: false
                }
              }
            }
        case actionTypes.SELECT_STOP:
            if (action.stop === 0) {
              if(!isStopOver0Selected) {
                Filters.ts.push(action.stop);
                isStopOver0Selected = !isStopOver0Selected;
              } else {
                const index = Filters.ts.indexOf(action.stop);
                if(index > -1) {
                  Filters.ts.splice(index, 1);
                }
                isStopOver0Selected = !isStopOver0Selected;
              }
            }
            if (action.stop === 1) {
              if(!isStopOver1Selected) {
                  Filters.ts.push(action.stop);
                  isStopOver1Selected = !isStopOver1Selected;
              } else {
                const index = Filters.ts.indexOf(action.stop);
                if(index > -1) {
                  Filters.ts.splice(index, 1);
                }
                isStopOver1Selected = !isStopOver1Selected;
              }
            }
            if(action.stop === 2) {
              if(!isStopOver2Selected) {
                Filters.ts.push(action.stop);
                isStopOver2Selected = !isStopOver2Selected;
              } else {
                const index = Filters.ts.indexOf(action.stop);
                if(index > -1) {
                  Filters.ts.splice(index, 1);
                }
                isStopOver2Selected = !isStopOver2Selected;
              }
            }
            let selectedStops = [...state.selectedStops];
            if(selectedStops.includes(action.stop)) {
              const selectedStopIndex = selectedStops.indexOf(action.stop);
              if(selectedStopIndex > -1) {
                selectedStops.splice(selectedStopIndex, 1);
              } 
            } else {
              selectedStops.push(action.stop);  
            }
            return {
              ...state,
              selectedStops: selectedStops
            }
        case actionTypes.APPLY_FILTERS:
            const temp10= [];
            let filteredResult = null;
            let oneWayFlightsSingleUpdated10 = null;
            let returnFlightsSingleUpdated10 = null;
            let internationalFilterResults = null;
            if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
              if(state.flightType === 'R') {
                oneWayFlightsSingleUpdated10 = state.dom.roundTripOnward;
                returnFlightsSingleUpdated10 = state.dom.roundTripReturn;
              } else {
                oneWayFlightsSingleUpdated10 = state.dom.oneWayFlightsSingle;
              }
            } else {
              if(state.flightType === 'R') {
                oneWayFlightsSingleUpdated10 = state.int.intRoundTripDepartOriginal;
                returnFlightsSingleUpdated10 = state.int.intRoundTripReturnOriginal;
              } else {
                oneWayFlightsSingleUpdated10 = state.int.oneWayFlightsSingle;
              }
            }
            if(returnFlightsSingleUpdated10 != null) {
              if(state.flightType === 'R' && (state.requestParams.destinationCountry !== 'IN' || state.requestParams.originCountry !== 'IN')) {
                internationalFilterResults = multiFilterInt(oneWayFlightsSingleUpdated10, returnFlightsSingleUpdated10);
              } else {
                const onwardResult = multiFilter(oneWayFlightsSingleUpdated10, Filters);
                const returnResult = multiFilter(returnFlightsSingleUpdated10, Filters, "return");
                filteredResult = {
                  roundTripOnward: onwardResult,
                  roundTripReturn: returnResult
                };
              }
            } else {
              filteredResult = multiFilter(oneWayFlightsSingleUpdated10, Filters);
            }
            if(state.flightType === 'O') {
              if(state.priceFilterSelected) {
                filteredResult = priceClickedHandler(oneWayFlightsSingleUpdated10);
              }
              if(state.durationFilterSelected) {
                filteredResult = durationClickedHandler(filteredResult);
              }
              if(state.departureFlightFiltersSelected) {
                filteredResult = departureClickedHandler(filteredResult);
              }
              if(state.arrivalFlightFiltersSelected) {
                filteredResult = arrivalClickedHandler(filteredResult);
              }
            } else {
              if(state.priceFilterSelected || state.returnPriceFilterSelected) {
                if(state.priceFilterSelected) {
                  filteredResult.roundTripOnward = priceClickedHandler(filteredResult.roundTripOnward);
                } else {
                  filteredResult.roundTripReturn = priceClickedHandler(filteredResult.roundTripReturn);
                }
              }
              if(state.durationFilterSelected || state.returnDurationFilterSelected) {
                if(state.durationFilterSelected) {
                  filteredResult.roundTripOnward = durationClickedHandler(filteredResult.roundTripOnward);
                } else {
                  filteredResult.roundTripReturn = durationClickedHandler(filteredResult.roundTripReturn);
                }
              }
              if(state.departureFlightFiltersSelected || state.returnDepartureFlightFiltersSelected) {
                if(state.departureFlightFiltersSelected) {
                  filteredResult.roundTripOnward = departureClickedHandler(filteredResult.roundTripOnward);  
                } else {
                  filteredResult.roundTripReturn = departureClickedHandler(filteredResult.roundTripReturn);
                }
              }
              if(state.arrivalFlightFiltersSelected || state.returnArrivalFlightFiltersSelected) {
                if(state.arrivalFlightFiltersSelected) {
                  filteredResult.roundTripOnward = arrivalClickedHandler(oneWayFlightsSingleUpdated10);
                } else {
                  filteredResult.roundTripReturn = arrivalClickedHandler(returnFlightsSingleUpdated10);
                }
              }
            }
            if(state.flightType === 'O') {
              [...filteredResult].forEach(flight => {
                temp10.push([flight]);
              })
            }
            if(state.flightType === 'R') {
              if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                return {
                  ...state,
                  dom: {
                    ...state.dom,
                    roundTripFlights: filteredResult
                  },
                  filters: JSON.parse(JSON.stringify(Filters))
                }
              } else {
                return {
                  ...state,
                  int: {
                    ...state.int,
                    intRoundTripDepart: internationalFilterResults.intRoundTripDepart,
                    intRoundTripReturn: internationalFilterResults.intRoundTripReturn
                  },
                  filters: JSON.parse(JSON.stringify(Filters))
                }
            }
            } else {
                if(state.requestParams.destinationCountry === 'IN' && state.requestParams.originCountry === 'IN') {
                  return {
                    ...state,
                    dom: {
                      ...state.dom,
                      oneWayFlightsCombined: temp10
                    },
                    filters: JSON.parse(JSON.stringify(Filters))
                  }
                } else {
                  return {
                    ...state,
                    int: {
                      ...state.int,
                      oneWayFlightsCombined: temp10
                    },
                    filters: JSON.parse(JSON.stringify(Filters))
                  }
              }
            }
        case actionTypes.CLEAR_FLIGHTS_DATA:
            return {
              ...state,
              serviceData: null,
              dom: {
                  oneWayFlightsSingle: [],
                  oneWayFlightsCombined: [],
                  roundTripFlights: {
                      roundTripOnward: [],
                      roundTripReturn: []
                  },
                  roundTripOnward: null,
                  roundTripReturn: null,
              },
              int: {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: null,
                intRoundTripDepart: [],
                intRoundTripReturn: []
              },
            }
        case actionTypes.RESET_SEARCH:
            return updateObject(state, {
              serviceData: null,
              requestParams: null,
              airportName: null,
              cityName: null,
              airlineNames: null,
              airportNames: null,
              cityNames: null,
              taxLabel: null,
              flightMessage: null,
              searchId: null,
              destination: '',
              flightCode: null,
              flightCodeRound: null,
              totalTravellers: 0,
              flightType: null,
              departDate: null,
              arrivalDate: null,
              isPriceClicked: false,
              isDurationClicked: false,
              searchUsed: true,
              loading: true,
              flightsNotFound: false,
              error: false,
              dom: {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: {
                    roundTripOnward: [],
                    roundTripReturn: []
                },
                roundTripOnward: null,
                roundTripReturn: null,
            },
            int: {
                oneWayFlightsSingle: [],
                oneWayFlightsCombined: [],
                roundTripFlights: null,
                intRoundTripDepart: [],
                intRoundTripReturn: []
              },
            })
        default:
            return state;
    }
}

const multiFilterInt = (oneWayFlightsSingle, returnFlightsSingle) => {
  let temp1= null;
  let temp2 = null;
  let filterResultsData = {
    intRoundTripDepart: [],
    intRoundTripReturn: []
  }

  for(let i=0; i < oneWayFlightsSingle.length; i++) {
    let filterKeys = Object.keys(Filters);

    let oneWayFlightsSingleClone = [...oneWayFlightsSingle[i]];
    temp1 = oneWayFlightsSingleClone.filter((item) => {
      const itemCopy = JSON.parse(JSON.stringify(item));
      itemCopy.FS[0].ts = item.FS.length - 1 >= '2' ? 2 : +item.FS.length - 1;
      itemCopy.FS[0].ft = item.FS[0].ft === "1" ? 1 : 0;

      if(parseInt(moment.duration(item.tlot).asHours(), 10) < 5) {
        itemCopy.FS[0].tlot = 0;
      } else if (parseInt(moment.duration(item.tlot).asHours(), 10) >= 5 && parseInt(moment.duration(item.tlot).asHours(), 10) < 10) {
        itemCopy.FS[0].tlot = 1;
      } else if (parseInt(moment.duration(item.tlot).asHours(), 10) >=10 && parseInt(moment.duration(item.tlot).asHours(), 10) < 15) {
        itemCopy.FS[0].tlot = 2;
      } else {
        itemCopy.FS[0].tlot = 3;
      }

      return filterKeys.every(key => {

        if(Filters[key].length !== 0) {
          return Filters[key].indexOf(itemCopy.FS[0][key]) !== -1;
        }
        return true;
        }
      );
    });

    let returnFlightsSingleClone = [...returnFlightsSingle[i]];
    temp2 = returnFlightsSingleClone.filter((item) => {
      const itemCopy = JSON.parse(JSON.stringify(item));
      itemCopy.FS[0].ts = item.FS.length - 1 >= '2' ? 2 : +item.FS.length - 1;
      itemCopy.FS[0].ft = item.FS[0].ft === "1" ? 1 : 0;

      if(parseInt(moment.duration(item.tlot).asHours(), 10) < 5) {
        itemCopy.FS[0].tlot = 0;
      } else if (parseInt(moment.duration(item.tlot).asHours(), 10) >= 5 && parseInt(moment.duration(item.tlot).asHours(), 10) < 10) {
        itemCopy.FS[0].tlot = 1;
      } else if (parseInt(moment.duration(item.tlot).asHours(), 10) >=10 && parseInt(moment.duration(item.tlot).asHours(), 10) < 15) {
        itemCopy.FS[0].tlot = 2;
      } else {
        itemCopy.FS[0].tlot = 3;
      }

      return filterKeys.every(key => {

        if(Filters[key].length !== 0) {
          return Filters[key].indexOf(itemCopy.FS[0][key]) !== -1;
        }
        return true;
        }
      );
    });
    if(temp1.length > 0 && temp2.length > 0) {
      filterResultsData.intRoundTripDepart.push(temp1);
      filterResultsData.intRoundTripReturn.push(temp2);
    }
  }
  return filterResultsData;
}

const multiFilter = (oneWayFlightsSingle, filters, flightType) => {
    let oneWayFlightsSingleClone = [...oneWayFlightsSingle];
    let filterKeys = Object.keys(Filters);
    if(filterKeys.includes('ddR') && flightType !== "return") {
      const ddrIndex = filterKeys.indexOf('ddR');
      if(ddrIndex > -1) {
        filterKeys.splice(ddrIndex, 1);
      }
    }
    if(filterKeys.includes('dd') && flightType === 'return') {
      const ddIndex = filterKeys.indexOf('dd');
      if(ddIndex > -1) {
        filterKeys.splice(ddIndex, 1);
      }
    }
    const temp = oneWayFlightsSingleClone.filter((item) => {
    const itemCopy = JSON.parse(JSON.stringify(item));
    itemCopy.OD[0].FS[0].ts = +item.OD[0].ts;
    itemCopy.OD[0].FS[0].ft = item.OD[0].FS[0].ft === "1" ? 1 : 0;
    if(parseInt(moment.duration(item.OD[0].tlot).asHours(), 10) < 5) {
      itemCopy.OD[0].FS[0].tlot = 0;
    } else if (parseInt(moment.duration(item.OD[0].tlot).asHours(), 10) >= 5 && parseInt(moment.duration(item.OD[0].tlot).asHours(), 10) < 10) {
      itemCopy.OD[0].FS[0].tlot = 1;
    } else if (parseInt(moment.duration(item.OD[0].tlot).asHours(), 10) >=10 && parseInt(moment.duration(item.OD[0].tlot).asHours(), 10) < 15) {
      itemCopy.OD[0].FS[0].tlot = 2;
    } else {
      itemCopy.OD[0].FS[0].tlot = 3;
    }
    if(parseInt(moment.duration(item.OD[0].FS[0].dd).asHours(), 10) < 6) {
      if(flightType === "return") {
        itemCopy.OD[0].FS[0].ddR = 0;  
      } else {
        itemCopy.OD[0].FS[0].dd = 0;
      }
    } else if (parseInt(moment.duration(item.OD[0].FS[0].dd).asHours(), 10) < 12) {
      if(flightType === "return") {
        itemCopy.OD[0].FS[0].ddR = 1;
      } else {
        itemCopy.OD[0].FS[0].dd = 1;
      }
    } else if (parseInt(moment.duration(item.OD[0].FS[0].dd).asHours(), 10) < 18) {
      if(flightType === "return") {
        itemCopy.OD[0].FS[0].ddR = 2;
      } else {
        itemCopy.OD[0].FS[0].dd = 2;
      }
    } else {
      if(flightType === "return") {
        itemCopy.OD[0].FS[0].ddR = 3;
      } else {
        itemCopy.OD[0].FS[0].dd = 3;
      }
    }

    return filterKeys.every(key => {
      if(Filters[key].length !== 0) {
        return Filters[key].indexOf(itemCopy.OD[0].FS[0][key]) !== -1;
      }
      return true;
      }
    );
  });
  return temp;
}

const durationClickedHandler = (oneWayFlightsSingle) => {
  const oneWayFlightsSingleClone = [].concat.apply([], oneWayFlightsSingle);
  oneWayFlightsSingleClone.sort(function(a, b) {
    return parseInt(moment.duration(a.OD[0].tdu).asSeconds(), 10) - parseInt(moment.duration(b.OD[0].tdu).asSeconds(), 10);
  });
  return oneWayFlightsSingleClone;
}

const departureClickedHandler = (oneWayFlightsSingle) => {
  const oneWayFlightsSingleClone = [].concat.apply([], oneWayFlightsSingle);
  oneWayFlightsSingleClone.sort(function(a, b) {
    return parseInt(moment.duration(a.OD[0].FS[0].dd).asSeconds(), 10) - parseInt(moment.duration(b.OD[0].FS[0].dd).asSeconds(), 10);
  });
  return oneWayFlightsSingleClone;
}

const arrivalClickedHandler = (oneWayFlightsSingle) => {
  const oneWayFlightsSingleClone = [].concat.apply([], oneWayFlightsSingle);
  oneWayFlightsSingleClone.sort(function(a, b) {
    return parseInt(moment.duration(a.OD[0].FS[a.OD[0].FS.length - 1].ad).asSeconds(), 10) - parseInt(moment.duration(b.OD[0].FS[b.OD[0].FS.length - 1].ad).asSeconds(), 10);
  });
  return oneWayFlightsSingleClone;
}

const priceClickedHandler = (oneWayFlightsSingle) => {
  const oneWayFlightsCombinedClone = [].concat.apply([], oneWayFlightsSingle);
  oneWayFlightsCombinedClone.sort(function(a, b) {
    return parseInt(a.FD.O.revisedFareDetails.tf, 10) - parseInt(b.FD.O.revisedFareDetails.tf, 10);
  });
  return oneWayFlightsCombinedClone;
}

const sortFlights = (flights, flightCode) => {
    let flightSchedule = [];
    let fareDetails = [];
		for (var keyVal = 0; keyVal < flights.resultData.length; keyVal++) {
          let data = flights.resultData[keyVal].fltSchedule[flightCode];
          if (data instanceof Array) {
            flightSchedule = flightSchedule.concat(flights.resultData[keyVal].fltSchedule[flightCode]);
          } else {
            for (let key in data) {
              flightSchedule.push(data[key]);
            }
          }
			    
					if(flights.eagerFetch==="true") {
				    fareDetails = fareDetails.concat(flights.resultData[keyVal].fareDetails[flightCode]);
					}
      }

	    let fareArray = [];
			for (let index in fareDetails) {
		    for (let fare in fareDetails[index]) {
		      fareArray.push([fare, fareDetails[index][fare]]);
		    }
    }

    let sortedFare = [];
    sortedFare = [...fareArray].sort(function(a, b) {
      return parseInt(a[1].O.revisedFareDetails.tf, 10) - parseInt(b[1].O.revisedFareDetails.tf, 10);
    });

    let sortedFlight = [];

    [...sortedFare].forEach(function(key) {
      let found = false;
      [...flightSchedule].forEach(function(item) {
        if (!found && item.ID === key[0]) {
          sortedFlight.push(item);
          found = true;
          return false;
        } else {
          return true;
        }
      });
    });

    [...sortedFlight].forEach(function(key) {
      let match = false;
      [...sortedFare].forEach(function(item) {
        if (!match && item[0] === key.ID) {
          key.FD = item[1];
          match = true;
          return false;
        } else {
          return true;
        }
      });
    });
    return sortedFlight;
}

const getOneWayFlights = (sortedFlight) => {
    const finalResult = airlineCombine(sortedFlight);
    return finalResult;
}

const getRoundTripFlights = (flights, flightCode, flightCodeRound) => {

        let flightScheduleR1 = [];
        let fareDetailsR1 = [];

        let flightScheduleR2 = [];
        let fareDetailsR2 = [];

// for loop to be added
			for (let keyVal = 0; keyVal < flights.resultData.length; keyVal++) {
        	flightScheduleR1 = flightScheduleR1.concat(flights.resultData[keyVal].fltSchedule[flightCode]);
					flightScheduleR2 = flightScheduleR2.concat(flights.resultData[keyVal].fltSchedule[flightCodeRound]);
					if(flights.eagerFetch === "true") {
							fareDetailsR1 = fareDetailsR1.concat(flights.resultData[keyVal].fareDetails[flightCode]);
							fareDetailsR2 = fareDetailsR2.concat(flights.resultData[keyVal].fareDetails[flightCodeRound]);
          }
			}

        let fareArrayR1 = [];
				for (let keyVal = 0; keyVal < fareDetailsR1.length; keyVal++) {
        		for (let fare in fareDetailsR1[keyVal]) {
          			fareArrayR1.push([fare, fareDetailsR1[keyVal][fare]]);
        		}
				}
        let sortedFareArrayR1 = [];

        sortedFareArrayR1 = fareArrayR1.sort(function(a, b) {
          return parseInt(a[1].O.revisedFareDetails.tf, 10) - parseInt(b[1].O.revisedFareDetails.tf, 10);
        });

        let sortedFlightScheduleR1 = [];

        [...sortedFareArrayR1].forEach(function(key) {
          let found = false;
          [...flightScheduleR1].forEach(function(item) {
            if (!found && item.ID === key[0]) {
              sortedFlightScheduleR1.push(item);
              found = true;
              return false;
            } else {
              return true;
            }
          });
        });

        [...sortedFlightScheduleR1].forEach(function(key) {
          let match = false;
          [...sortedFareArrayR1].forEach(function(item) {
            if (!match && item[0] === key.ID) {
              key.FD = item[1];
              match = true;
              return false;
            } else {
              return true;
            }
          });
        });



        let fareArrayR2 = [];
				for (let keyVal = 0; keyVal < fareDetailsR2.length; keyVal++) {
	        for (let fare in fareDetailsR2[keyVal]) {
	          fareArrayR2.push([fare, fareDetailsR2[keyVal][fare]]);
	        }
				}

        let sortedFareArrayR2 = [];
        sortedFareArrayR2 = fareArrayR2.sort(function(a, b) {
          return parseInt(a[1].O.revisedFareDetails.tf, 10) - parseInt(b[1].O.revisedFareDetails.tf, 10);
        });

        let sortedFlightScheduleR2 = [];

        [...sortedFareArrayR2].forEach(function(key) {
          let found = false;
          [...flightScheduleR2].forEach(function(item) {
            if (!found && item.ID === key[0]) {
              sortedFlightScheduleR2.push(item);
              found = true;
              return false;
            } else {
              return true;
            }
          });
        });

        [...sortedFlightScheduleR2].forEach(function(key) {
          let match = false;
          [...sortedFareArrayR2].forEach(function(item) {
            if (!match && item[0] === key.ID) {
              key.FD = item[1];
              match = true;
              return false;
            } else {
              return true;
            }
          });
        });

        return {
          roundTripOnward: sortedFlightScheduleR1,
          roundTripReturn: sortedFlightScheduleR2
        }
}

function airlineCombine(airline) {
    let finalResult = [];
    let temp = [];
    for (let i = 0; i < airline.length; i++) {
      temp.push(airline[i]);
      for (let j = i + 1; j < airline.length; j++) {
        if (
          airline[i].FD.O.revisedFareDetails.tf == airline[j].FD.O.revisedFareDetails.tf &&
          airline[i].OD[0].FS[0].ac == airline[j].OD[0].FS[0].ac
        ) {
          temp.push(airline[j]);
          const index = airline.indexOf(airline[j]);
          if (index !== -1) {
            airline.splice(index, 1);
          }
          j--;
        }
      }
      finalResult.push(temp);
      temp = [];
    }
    // for(let item of airline) {
    //   console.log(item);
    //    if(!(finalResult[item.FD.O.revisedFareDetails.tf])) finalResult[item.FD.O.revisedFareDetails.tf] = [];
    //    finalResult[item.FD.O.revisedFareDetails.tf].push(item);
    // }
    return finalResult;
  }

  function removeDuplicatesHandler(originalArray, fid) {
    let temp = [];
    let lookupObject = {};
    for(const i in originalArray) { 
        lookupObject[originalArray[i][fid]] = originalArray[i];
    }
    for(const i in lookupObject) { 
        temp.push(lookupObject[i]); 
    }
    return temp;
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/flights.js